import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { AppDispatch } from '@/store'
import type { LanguageType } from '@/constants'

const initialState: LanguageType = {
  label: 'English',
  lang: 'en',
  languageType: 'en',
  antd: 'en_US',
}

const languageSlice = createSlice({
  name: 'language',
  initialState: initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<LanguageType>): LanguageType {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const changeLanguage = (lang: LanguageType) => (dispatch: AppDispatch) => {
  dispatch(languageSlice.actions.setLanguage(lang))
}

export const { setLanguage } = languageSlice.actions
export default languageSlice.reducer
